import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import Vue from "vue";
export const SET_ACCOUNT_PAGE = "SET_ACCOUNT_PAGE";
export const SET_ACCOUNT_LIMITS = "SET_ACCOUNT_LIMITS";
export const SET_ACCOUNT_LIMIT = "SET_ACCOUNT_LIMIT";
export const SET_PAYMENT_DETAILS = "SET_PAYMENT_DETAILS";
export const SET_SUBSCRIBING_CURRENT_ACCOUNT = "SET_SUBSCRIBING_CURRENT_ACCOUNT";
const mutations = {
  [SET_ACCOUNT_PAGE]: (state, {
    page
  }) => {
    state.currentPagePlan = page;
  },
  [SET_ACCOUNT_LIMITS]: (state, accountLimits) => {
    Vue.set(state.accountLimits, "byId", accountLimits.byId);
    Vue.set(state.accountLimits, "allIds", accountLimits.allIds);
  },
  [SET_ACCOUNT_LIMIT]: (state, {
    accountLimit,
    page
  }) => {
    var _context;
    Vue.set(state.accountLimits.byId, page, accountLimit);
    if (!_includesInstanceProperty(_context = state.accountLimits.allIds).call(_context, page)) Vue.set(state.accountLimits, "allIds", [...state.accountLimits.allIds, page]);
  },
  [SET_PAYMENT_DETAILS]: (state, details) => {
    state.paymentDetails = details;
  },
  [SET_SUBSCRIBING_CURRENT_ACCOUNT]: (state, subscribingCurrentAccount) => {
    state.subscribingCurrentAccount = subscribingCurrentAccount;
  }
};
export default mutations;